
import CommonsHeader from "./components/Header.vue";
import Loading from "./components/Loading.vue";
import { mapState, mapActions } from "vuex";
import Toast from 'vux/src/components/toast/index.vue'

import CommonsBottom from "./components/Bottom.vue";
import ContractPopup from "./components/contractPopup.vue";

export default {
components: {
CommonsHeader,
Loading,
Toast,
CommonsBottom,
ContractPopup
},
provide() {
return {
reload: this.reload
};
},
data() {
return {
isRouterAlive: true
};
},
computed: {
...mapState(["loadingShow", "toastShow", "toastMsg", "toastWidth"]),
returnToastShow: {
get() {
return this.toastShow;
},
set() {}
}
},
created() {
const _this = this;
_this.$store.commit("UPDATE_LOADING", true);

window.addEventListener(
"popstate",
function(e) {

const contractPopup = { isShowContract: false };
_this.$store.commit("SET_CONTRACT_POPUP", contractPopup);


if (
_this.$route.path === "/home" ||
_this.$route.path === "/backMoney" ||
_this.$route.path === "/me" ||
_this.$route.path === "/more"
) {
history.pushState(null, null, document.URL);
}
},
false
);
},
mounted() {

this.setProductNameSateFromCookid();

var _this = this;
_this.$router.beforeEach(function(to, from, next) {
_this.$store.commit("UPDATE_LOADING", true);
next();
});
_this.$router.afterEach(function(to) {
_this.$store.commit("UPDATE_LOADING", false);
});
_this.$router.beforeEach(function(to, from, next) {




if (
to.path === "/" ||
to.path === "/home" ||
to.path === "/login" ||
to.path === "/nofind" ||
to.path === "/register" ||
to.path === "/forgetPass" ||
to.path === "/productDetail" ||
to.path === "/productList"
) {
next();
} else {

var UserToken = _this.$Utils.getCookie("UserToken");
if (UserToken) {
next();
} else {
_this.$store.commit("UPDATE_LOADING", false);
next({ path: "/login" });

}
}
});
_this.$router.afterEach(function(to) {
_this.$store.commit("UPDATE_LOADING", false);
});
},

















watch: {
$route(to, from) {
this.setProductNameSateFromCookid();
}
},
methods: {
...mapActions(["setProductNameSate", "setProductNameSateFromCookid"]),
onHide() {
this.$store.commit("CLEARSHOWTOAST");
},
reload() {
this.isRouterAlive = false;
this.$nextTick(function() {
this.isRouterAlive = true;
});
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue